import React from 'react';
import { Icon, message } from 'antd';
import {
  Actions,
  Container,
  CopyButton,
  Legend,
  Loading,
  ReferenceBlock,
  ReferenceText
} from './styles';

const PAGE_RANGE_PLACEHOLDER = 'página inicial-página final';

const PAGE_RANGE_LEGEND = `* Altere os intervalos "${PAGE_RANGE_PLACEHOLDER}" para as páginas constantes no documento.`;

interface IProps {
  citation: string;
  loading?: boolean;
}

const getPlainText = (citation: string) => {
  const element = document.createElement('div');
  element.innerHTML = citation;
  return String(element.textContent || '')
    .replace(/\s+/g, ' ')
    .trim();
};

const copyToClipboard = async (text: string) => {
  if (navigator.clipboard && window.isSecureContext) {
    await navigator.clipboard.writeText(text);
    return;
  }

  const textArea = document.createElement('textarea');
  textArea.value = text;
  textArea.style.position = 'fixed';
  textArea.style.opacity = '0';
  document.body.appendChild(textArea);
  textArea.select();
  document.execCommand('copy');
  document.body.removeChild(textArea);
};

export const BibliographicReference = ({ citation, loading }: IProps) => {
  if (loading || !citation) {
    return (
      <Container>
        <Loading>
          <Icon type="loading" />
        </Loading>
      </Container>
    );
  }

  const copy = async () => {
    try {
      await copyToClipboard(getPlainText(citation));
      message.success('Referência copiada.');
    } catch (error) {
      message.error('Não foi possível copiar a referência.');
    }
  };

  return (
    <Container>
      <ReferenceBlock>
        <ReferenceText
          lang="pt-BR"
          dangerouslySetInnerHTML={{ __html: citation }}
        />
      </ReferenceBlock>
      {citation.includes(PAGE_RANGE_PLACEHOLDER) ? (
        <Legend>{PAGE_RANGE_LEGEND}</Legend>
      ) : null}
      <Actions>
        <CopyButton type="button" onClick={copy}>
          <Icon type="copy" />
          Copiar referência
        </CopyButton>
      </Actions>
    </Container>
  );
};
